import { combineReducers } from '@reduxjs/toolkit';
import createSubjectNoteReducer from './create-subject-note';
import getSubjectNoteListReducer from './get-subject-note-list';

const subjectNoteReducer = combineReducers({
  createSubjectNote: createSubjectNoteReducer,
  getSubjectNoteList: getSubjectNoteListReducer
});

export default subjectNoteReducer;